import React, { useState, useContext } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { UserContext } from '../../context/UserContext';
import { isBlockedError, getBlockedErrorMessage } from '../../utils/moderationErrors';
import { BASE_URL } from '../../api/config';
import HrnbForm from "../controls/HrnbForm";
import HrnbFormControl from "../controls/HrnbFormControl";
import HrnbButton from "../controls/HrnbButton";
import { LoginIcon, RegisterIcon } from "../../icons";
const API_ROOT = new URL(BASE_URL).origin;
const VK_AUTH_URL = `${API_ROOT}/oauth2/authorization/vk`;


const VK_ICON = (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" style={{ flexShrink: 0 }}>
        <path d="M15.684 0H8.316C3.732 0 0 3.732 0 8.316v7.368C0 20.268 3.732 24 8.316 24h7.368C20.268 24 24 20.268 24 15.684V8.316C24 3.732 20.268 0 15.684 0zm3.516 16.608h-1.536c-.576 0-.744-.48-1.728-1.536-.864-.828-1.248-.936-1.464-.936-.312 0-.396.084-.396.492v1.272c0 .36-.12.576-1.08.576-1.596 0-3.36-.984-4.608-2.808-1.584-2.028-2.004-3.516-2.004-3.828 0-.192.084-.36.48-.36h1.536c.36 0 .492.156.636.54.684 1.812 1.848 3.408 2.328 3.408.18 0 .264-.096.264-.624v-2.436c0-.984-.588-1.068-.588-1.416 0-.168.144-.324.384-.324h2.424c.324 0 .432.168.432.528v2.856c0 .324.144.432.24.432.192 0 .348-.108.552-.348.684-.828 1.248-2.112 1.248-2.112.072-.156.18-.312.54-.312h1.536c.348 0 .432.18.348.54-.144.672-1.728 2.496-1.728 2.496-.132.192-.18.3 0 .528.132.168.564.552.852.864.636.708 1.116 1.296 1.248 1.704.12.384-.06.588-.444.588z"/>
    </svg>
);

export default function HrnbLoginForm({ onClose, onSwitchRegister }) {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const { signIn } = useContext(UserContext);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!username.trim() || !password) {
            alert("Заполните логин и пароль");
            return;
        }
        setLoading(true);
        try {
            await signIn({ username, password });
            navigate('/cabinet');
            if (onClose) onClose();
        } catch (err) {
            if (isBlockedError(err)) {
                alert(getBlockedErrorMessage(err));
            } else {
                const msg = err?.response?.data?.message || err?.message || 'Ошибка авторизации';
                alert(msg);
            }
        } finally {
            setLoading(false);
        }
    };

    const handleChange = setter => e => setter(e.target.value);

    return (
        <HrnbForm onSubmit={handleSubmit}>
            <HrnbFormControl
                as="text"
                value={username}
                onChange={handleChange(setUsername)}
                placeholder="Введите логин"
                label="Логин:"
                style={{ marginTop: 12 }}
                autoFocus
            />
            <HrnbFormControl
                as="password"
                value={password}
                onChange={handleChange(setPassword)}
                placeholder="Введите пароль"
                label="Пароль:"
                style={{ marginTop: 12 }}
            />
            <div style={{ marginTop: 8 }}>
                <Link to="/forgot-password" onClick={() => onClose && onClose()} style={{ fontSize: 14, color: '#0d6efd' }}>
                    Забыли пароль?
                </Link>
            </div>
            <div style={{ marginTop: 12 }}>
                <a
                    href={VK_AUTH_URL}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 8,
                        width: '100%',
                        padding: '10px 16px',
                        borderRadius: 8,
                        background: '#0077FF',
                        color: '#fff',
                        textDecoration: 'none',
                        fontWeight: 600,
                        fontSize: 14,
                        border: 'none',
                        cursor: 'pointer',
                    }}
                >
                    {VK_ICON}
                    Войти через ВКонтакте
                </a>
            </div>
            <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
                <HrnbButton
                    type="submit"
                    style={{ flex: 1 }}
                    icon={<LoginIcon />}
                    disabled={loading}
                >
                    {loading ? 'Вход...' : 'Войти'}
                </HrnbButton>
                <HrnbButton
                    type="button"
                    variant="ghost"
                    onClick={() => onSwitchRegister && onSwitchRegister()}
                    disabled={loading}
                    icon={<RegisterIcon />}
                >
                    Регистрация
                </HrnbButton>
            </div>
        </HrnbForm>
    );
}
